import { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { GetTrackingByRound } from '../../../services/api';
import { Marker, Popup, Polyline } from 'react-leaflet';
import MapaBase from './MapaBase';
import { peTime } from '../../../util/util';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import rutaInicioPng from '../../../assets/ruta_inicio.png';
import rutaFinPng from '../../../assets/ruta_fin.png';
import { minutesDiffDisplay } from '../../../helper/dateHelper';

export default function MapaTrackingPorRonda({ round, assignment, pointControls }) {
  const { token } = useAuth();
  const [listTracking, setListTracking] = useState([]);

  useEffect(() => {
    const pintarTracking = async () => {
      if (!round?.id) {
        setListTracking([]);
        return;
      }

      const dataTracking = await GetTrackingByRound({ roundId: round.id, token });
      setListTracking(Array.isArray(dataTracking) ? dataTracking : []);
    };

    pintarTracking();
  }, [round?.id, token]);

  const iconInicio = useMemo(
    () =>
      L.icon({
        iconUrl: rutaInicioPng,
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -28],
      }),
    []
  );

  const iconFin = useMemo(
    () =>
      L.icon({
        iconUrl: rutaFinPng,
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -28],
      }),
    []
  );

  return (
    <>
      <h1>Patio {assignment?.yardName}</h1>
      <div className="col-12">
        <div className="card shadow-sm h-100">
          <div className="card-header bg-white d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2">
            <div className="d-flex flex-wrap align-items-center gap-3">
              <small className="d-flex align-items-center gap-1 text-center">
                Inicio: <img src={rutaInicioPng} alt="Inicio" width={25} height={25} />
              </small>
              <h6 className='m-auto'>{peTime(listTracking[0]?.hourDate)}</h6>
              -
              <small className="d-flex align-items-center gap-1 text-center">
                Fin: <img src={rutaFinPng} alt="Fin" width={25} height={25} />
              </small>
              <h6 className='m-auto'>{peTime(listTracking[listTracking.length - 1]?.hourDate)}</h6>
              <small className="d-flex align-items-center gap-1 text-center">
                Tiempo (Minutos): {minutesDiffDisplay(listTracking[0]?.hourDate, listTracking[listTracking.length - 1]?.hourDate) || "0"}
              </small>
            </div>
          </div>
        </div>
      </div>
      <MapaBase assignment={assignment} pointControls={pointControls}>
        {listTracking.length > 0 && (
          <Polyline
            positions={listTracking.map((p) => [p.latitude, p.longitude])}
            pathOptions={{ color: 'red', weight: 5 }}
          />
        )}

        {listTracking.length > 0 && (
          <Marker
            position={[listTracking[0].latitude, listTracking[0].longitude]}
            icon={iconInicio}
          >
            <Popup>
              <div className='d-flex flex-column align-items-center gap-2'>
                <strong className="">Inicio {round?.name}</strong>
                <h6>{peTime(listTracking[0].hourDate)}</h6>
              </div>
            </Popup>
          </Marker>
        )}

        {listTracking.length > 1 && (
          <Marker
            position={[
              listTracking[listTracking.length - 1].latitude,
              listTracking[listTracking.length - 1].longitude,
            ]}
            icon={iconFin}
          >
            <Popup>
              <div className='d-flex flex-column align-items-center gap-2'>
                <strong className="">Fin {round?.name}</strong>
                <h6>{peTime(listTracking[listTracking.length - 1].hourDate)}</h6>
              </div>
            </Popup>
          </Marker>
        )}
      </MapaBase>
    </>
  );
}
